import React, {useEffect, useMemo} from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { Field, change } from 'redux-form'
import { connect } from 'react-redux'

import CustomSelectRedesign from 'js/components/shared/FormElements/CustomSelectRedesign';
import {SEARCH_FILTERS_FORM} from '../../../../constants';

import styles from './RoomSelectField.module.scss'

const cx = classnames.bind(styles);

const required = (value) => value ? undefined : 'Required'

const RoomSelectField = function ({
  name,
  value,
  label,
  description,
  onChange,
  wordings,
  isHighlighted = false,
  minValue = 0,
  maxValue = 18,
  changeFieldAction,
}) {
  const getLabel = (value) => `${value} ${value > 1 ? wordings.multipleLabel : wordings.singleLabel}`

  const options = useMemo(function () {
    return [...Array(maxValue - minValue + 1).keys()].map(el => {
      return {
        value: el + minValue + '',
        label: getLabel(el + minValue)
      }
    })
  }, [minValue, maxValue])

  const onSelectUpdate = function (val) {
    onChange(val)
  }

  const selectPlaceholder = useMemo(function () {
    return value > maxValue ? getLabel(value) : '-'
  }, [])

  useEffect(() => {
    changeFieldAction(name, value)
  }, []);

  return (
    <div className={cx('room-field')}>
      <div>
        <div className={cx('label')}>
          {label}
        </div>
        {description && (
          <div className={cx('description')}>
            {description}
          </div>
        )}
      </div>
      <Field
        name={name}
        value={value + ''}
        component={CustomSelectRedesign}
        validate={[required]}
        onChange={onSelectUpdate}
        dropdownPosition="top"
        dropdownHeight={170}
        className={cx('select', {'highlighted': isHighlighted})}
        options={options}
        searchable={false}
        withValidateIcons={false}
        placeholder={selectPlaceholder}
        validClassname={cx('select-valid')}
        errorClassname={cx('select-error')}
      />
    </div>
  )
}

RoomSelectField.propTypes = {
  data: PropTypes.any,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  wordings: PropTypes.shape({
    singleLabel: PropTypes.string,
    multipleLabel: PropTypes.string,
    defaultLabel: PropTypes.string
  }).isRequired,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  isHighlighted: PropTypes.bool,
}

export default connect(
  () => ({}),
  (dispatch) => ({
    changeFieldAction: (name, value, touched = false) => dispatch(change(SEARCH_FILTERS_FORM, name, value, touched))
  })
)(RoomSelectField);
